import { AlgoliaEnv } from "./environment";
export var AlgoliaIndexSuffix;
(function (AlgoliaIndexSuffix) {
    AlgoliaIndexSuffix["BOOKINGS"] = "BOOKINGS";
    AlgoliaIndexSuffix["DENORMALIZED_ORDERS"] = "denormalized_ORDERS";
    AlgoliaIndexSuffix["DRAFT_WAYPOINTS"] = "DRAFT_WAYPOINTS";
    AlgoliaIndexSuffix["DRAFT_WAYPOINTS_DESCENDING"] = "DRAFT_WAYPOINTS_descending";
    AlgoliaIndexSuffix["FEEDBACK"] = "FEEDBACK";
    AlgoliaIndexSuffix["ICD_10_CODES"] = "ICD_10_CODES";
    AlgoliaIndexSuffix["ITINERARIES"] = "ITINERARIES";
    AlgoliaIndexSuffix["OFFICES"] = "OFFICES";
    AlgoliaIndexSuffix["ORDERS"] = "ORDERS";
    AlgoliaIndexSuffix["PLACES"] = "PLACES";
    AlgoliaIndexSuffix["PROCEDURES"] = "PROCEDURES";
    AlgoliaIndexSuffix["PRODUCTS"] = "PRODUCTS";
    AlgoliaIndexSuffix["SHIFTS"] = "SHIFTS";
    AlgoliaIndexSuffix["SHIFTS_DESCENDING"] = "SHIFTS_descending";
    AlgoliaIndexSuffix["SUPPLY_SHIPMENTS"] = "SUPPLY_SHIPMENTS";
    AlgoliaIndexSuffix["SUPPLY_TRANSFERS"] = "SUPPLY_TRANSFERS";
    AlgoliaIndexSuffix["USERS"] = "USERS";
    AlgoliaIndexSuffix["WAYPOINTS"] = "WAYPOINTS";
})(AlgoliaIndexSuffix || (AlgoliaIndexSuffix = {}));
export const getAlgoliaEnv = (isProd, isEmulatedDb) => {
    if (isProd)
        return AlgoliaEnv.PRODUCTION;
    if (isEmulatedDb)
        return AlgoliaEnv.LOCAL;
    return AlgoliaEnv.DEVELOPMENT;
};
export const DEFAULT_FRAGMENT_SIZE = 5;
export const isFragmented = (value) => !!value.fragmentIDs;
export const isFragment = (value) => !!value.isFragment;
//# sourceMappingURL=algolia.js.map